import { registerPlugin } from '@capacitor/core';
import { withBridgedStackTrace } from '../withBridgedStackTrace';
import { RerouteDeepLinkPluginInterface } from './definitions';
import { CAPACITOR_REROUTE_DEEP_LINK_PLUGIN } from '../pluginConstants';

const RerouteDeepLinkPluginRaw = registerPlugin<RerouteDeepLinkPluginInterface>(CAPACITOR_REROUTE_DEEP_LINK_PLUGIN);
const RerouteDeepLinkPlugin = withBridgedStackTrace(RerouteDeepLinkPluginRaw, CAPACITOR_REROUTE_DEEP_LINK_PLUGIN);

export * from './definitions';
export { RerouteDeepLinkPlugin };
